import React from "react";

class Checkbox extends React.PureComponent {
  constructor(props) {
    super(props);

    this.handleOnChange = this.handleOnChange.bind(this);
  }

  handleOnChange(event) {
    this.props.onChange(event.target.checked);
  }

  render() {
    const { isChecked, isDisabled } = this.props;
    return (
      <>
        <input
          id={this.props.id}
          className={`${
            isDisabled
              ? "cursor-not-allowed opacity-50"
              : "hover:shadow cursor-pointer"
          }`}
          style={{ transform: "scale(1.2)" }}
          type="checkbox"
          checked={isChecked}
          onClick={(e) => e.stopPropagation()}
          onChange={this.handleOnChange}
          disabled={isDisabled || false}
        ></input>
      </>
    );
  }
}

export default Checkbox;
